/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_TEMPLATE_CATEGORIES,
  GET_TEMPLATE_CATEGORIES_SUCCESS,
  GET_TEMPLATE_CATEGORIES_ERROR,
} from 'src/actions/templateCategoriesActions';

// Host Templates v2 — template categories slice.
//
// Loaded once after login. The Host Templates list view reads via
// selectors in src/selectors/templateCategoriesSelectors.js to drive
// category-grouped rendering.

const initialState = {
  loading: false,
  loaded: false,
  byId: {}, // map: category id → category row
  list: [], // ordered array (by sortOrder ASC, as returned by API)
  error: null,
};

const templateCategoriesReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_TEMPLATE_CATEGORIES: {
      return produce(state, (draft) => {
        draft.loading = true;
        draft.error = null;
      });
    }

    case GET_TEMPLATE_CATEGORIES_SUCCESS: {
      return produce(state, (draft) => {
        const list = Array.isArray(payload?.templateCategories)
          ? payload.templateCategories
          : [];
        draft.loading = false;
        draft.loaded = true;
        draft.list = list;
        draft.byId = Object.fromEntries(list.map((row) => [row.id, row]));
        draft.error = null;
      });
    }

    case GET_TEMPLATE_CATEGORIES_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
        // Mark loaded even on failure so the list view resolves to a
        // loaded/empty state instead of hanging its spinner forever.
        draft.loaded = true;
        draft.error = payload?.error || 'Failed to load template categories';
      });
    }

    default:
      return state;
  }
};

export default templateCategoriesReducer;
